import { ValidateMessageMapper } from "../utils/mappers/validator_message_mapper";

export const ValidatorHelper = {
  validateIsNotEmpty(value: string | null | undefined): String | null {
    if (value == null || String(value).trim() === "") return ValidateMessageMapper.fieldEmpty;
    return null;
  },

  name(value: string | null | undefined): String | null {
    if (value == null || String(value).trim() === "") return ValidateMessageMapper.nameEmpty;
    const regex = /^[A-Za-zÀ-ÖØ-öø-ÿ\s]+$/;
    return regex.test(String(value)) ? null : ValidateMessageMapper.nameInvalid;
  },

  email(email: string | null | undefined): String | null {
    const trimmed = email == null ? "" : String(email).trim();
    if (trimmed === "") return ValidateMessageMapper.emailEmpty;
    if (trimmed.length > 81) return ValidateMessageMapper.emailTooLong;
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return emailRegex.test(trimmed) ? null : ValidateMessageMapper.emailInvalid;
  },

  message(value: string | null | undefined, minLength = 10): String | null {
    const trimmed = value == null ? "" : String(value).trim();
    if (trimmed === "") return ValidateMessageMapper.messageEmpty;
    if (trimmed.length < minLength) return ValidateMessageMapper.messageTooShort;
    return null;
  },
};
